import { AuthenticationResult, EventMessage, EventType, PublicClientApplication } from '@azure/msal-browser';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { client } from './api/client.gen.js';
import App from './App';
import { msalConfig } from './authConfig.js';
import { azureFetchToken } from './authHelper.js';
import './i18n';

const msalInstance = new PublicClientApplication(msalConfig);
await msalInstance.initialize();
await msalInstance.handleRedirectPromise();

const accounts = msalInstance.getAllAccounts();
if (accounts.length > 0) {
  msalInstance.setActiveAccount(accounts[0]);
}

msalInstance.addEventCallback((event: EventMessage) => {
  if (event.eventType === EventType.LOGIN_SUCCESS && event.payload) {
    const payload = event.payload as AuthenticationResult;
    const account = payload.account;
    msalInstance.setActiveAccount(account);
  }
});

client.setConfig({
  baseUrl: import.meta.env.VITE_API_BASE_URL,
});

// Refresh the MSAL token on every request so it never goes stale.
// MSAL caches the token internally and only makes a network call when it's
// close to expiry, so this does not add meaningful latency on most requests.
client.interceptors.request.use(async (request) => {
  const token = await azureFetchToken(msalInstance);
  if (token) {
    request.headers.set('Authorization', token);
  }
  return request;
});

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App msalInstance={msalInstance} />
  </StrictMode>,
);
